<div *ngIf="ConflictingFormInstance && ConflictingFormInstance.canView" class="conflict-warning-box">
    <mat-card appearance="outlined" class="conflict-header-background">
        <mat-card-title class="conflict-warning-header">
            <i class="fa fa-exclamation-circle"></i>
            &nbsp;Save Conflict
        </mat-card-title>
        <!--//VNEXT-950: KLW - Changes to the text for save conflict-->
        <mat-card-content class="conflict-warning-text">
            Your changes were not saved because new updates were made by someone else.
            <br>
            <p>&emsp;• The <b>“Your changes to …”</b> section below shows your pending edits for reference. </p>
            <p>&emsp;• The <b>“Current Version of …”</b> section at the <a fragment="updated-instance" class="navigate-link" (click)="navigateToSection('updated-instance')">bottom of this page</a> shows the latest version of the form.</p>
            <br>
            Please either:
            <br>
            <p>&emsp;1) Add any changes to the <b>“Current Version”</b> section and click <b>“Save”</b> or </p>
            <p>&emsp;2) Click <b>“Discard Edits”</b> to remove your pending edits and cancel the save. </p>
        </mat-card-content>
    </mat-card>
    <br />
    <mat-card appearance="outlined">
        <mat-card-title class="conflict-warning-header">
            Your changes to {{ConflictingFormInstance.name}}
        </mat-card-title>
    </mat-card>
</div>

<div *ngIf="this.workflowChangeConflict" class="conflict-warning-box">
    <mat-card appearance="outlined">
        <mat-card-title class="conflict-warning-header">
            <i class="fa fa-exclamation-circle"></i>
            &nbsp;Form has Changed
        </mat-card-title>
        <mat-card-content class="conflict-warning-text">
            Someone else edited this form before you updated the workflow state.
            Please <a href="javascript:window.location.reload(true)">refresh</a> the form and confirm the changes before updating the state.
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="ConflictingFormInstance && !ConflictingFormInstance.canView" class="conflict-warning-box">
    <mat-card appearance="outlined">
        <mat-card-title class="conflict-warning-header">
            <i class="fa fa-exclamation-circle"></i>
            &nbsp;Editing Conflict
        </mat-card-title>
        <mat-card-content class="conflict-warning-text">
            Someone else saved a new version of this form while you were editing it, and it's now in a state
            that's inaccessible to you.  Your changes cannot be saved, but they're still in the browser, shown below.
            You may print your form using the Print button if you'd like to keep a record of your changes.
        </mat-card-content>
    </mat-card>
    <br />
    <mat-card appearance="outlined">
        <mat-card-title class="conflict-warning-header">
            Your changes to {{ConflictingFormInstance.name}}
        </mat-card-title>
    </mat-card>
</div>

<app-form-renderer #originalFormRenderer
                   [showSaveDiscard]="this.HideShowSaveDiscard"
                   [form]="this.Form"
                   [formInstance]="this.FormInstance"
                   [isClosable]="IsClosable"
                   [mode]="'instance'"
                   [buttonsEnabled]="this.ConflictingFormInstance === null || this.ConflictingFormInstance === undefined"
                   (onSave)="this.onFormInstanceSave($event)"
                   (onTransition)="this.onTransition($event)"
                   (notifySubscribers)="onNotifySubscribers($event)"
                   (onReset)="this.onFormInstanceReset($event)"
                   (onClose)="this.onFormInstanceClose($event)"
                   (onRequestService)="this.onRequestService($event)">
</app-form-renderer>

<div *ngIf="ConflictingFormInstance && ConflictingFormInstance.canView" class="conflict-warning-box" id="updated-instance">
    <br />
    <mat-card appearance="outlined" id="updatedinstance">
        <mat-card-title class="conflict-warning-header">Current version of {{ConflictingFormInstance.name}}</mat-card-title>
        <mat-card-content>
            Last modified by {{ConflictingFormInstance.modifiedByUserName}} {{ConflictingFormInstanceFriendlyModifiedDate}}.
        </mat-card-content>
    </mat-card>
</div>
<app-form-renderer *ngIf="this.ConflictingFormInstance && ConflictingFormInstance.canView"
                   #conflictingFormRenderer
                   [formInstance]="this.ConflictingFormInstance"
                   [showTransitions]="this.HideShowTransitions"
                   [mode]="'instance'"
                   [form]="this.ConflictingFormInstance.form" 
                   [buttonsEnabled]="true"
                   (onSave)="this.onFormInstanceSave($event)"
                   (onTransition)="this.onTransition($event)"
                   (notifySubscribers)="onNotifySubscribers($event)"
                   (onReset)="this.onFormInstanceReset($event)"
                   (onRequestService)="this.onRequestService($event)">
</app-form-renderer>
